export class ListContractorFilesRequest {

    _term = undefined; // string
    _page = undefined; // number
    _contractorId = undefined; // number

    constructor() {
        this._page = 1;
        this._term = '';
        this._contractorId = undefined;
    }

    setPage(page) {
        this._page = page;
    }

    setTerm(term) {
        this._term = term;
    }

    setContractorId(id) {
        this._contractorId = id;
    }

    body() {
        return {
            criteria: {
                term: this._term,
                page: this._page,
                limit: undefined,
                contractor_id: this._contractorId,
            }
        }
    }
}



// WEBPACK FOOTER //
// ./src/app/documentary-library/list/webservices/list-documentary-library/ListContractorFilesRequest.js